export const UPLOAD_FILE_METADATA_DESC = {
  image: ['Supported file types: PNG, JPG, JPEG.', '(max. 800x400px , 1MB)']
};

export const UPLOAD_FILE_EDITOR_DESC = {
  image: ['Supported file types: PNG, JPG, JPEG, GIF, MP4, WEBM, OGG.', 'Maximum file size: 10MB']
};

export const UPLOAD_FILE_SUBMISSIONS_DESC = {
  all: [
    'Supported file types: PNG, JPG, JPEG, GIF, WEBP, WEBM, MP4, OGG.',
    'Maximum file size: 10MB'
  ],
  image: ['Supported file types: PNG, JPG, JPEG, GIF, WEBP.', '(max. 800x400px , 10MB)'],
  video: ['Supported file types: MP4, OGG, WEBM.', 'Maximum file size: 10MB']
};

export const AI_SUMMARY_SUPPORT =
  'Enable AI summaries to automatically generate concise overviews of your article for quick reading.';

export const EARNING_TEXT = [
  "Earnings reflect the total amount you've made from published articles based on views and engagements.",
  'Paid upon reaching the USD 100 payment threshold.'
];

export const INVESTMENT_POOL_TOOLTIP = (
  <p>
    Set how much of your article's ad revenue followers can invest in. <br />
    <br />
    <b>Recommended:</b> New writers may want to set a higher investment pool to attract early
    supporters. Established creators with loyal followers can usually set a lower percentage.
  </p>
);

export const REVENUE_BREAKDOWN_TOOLTIP = (
  <p>
    <b>How it works:</b>
    <br />
    Of all ad revenue, 10% goes to the platform, and a minimum of 5% goes to the investment pool.
    You can increase the investment pool size (up to 90%) to attract more investors, though this
    reduces your direct earnings.
    <br />
    <br />
    Recommended: 5-15% for new articles
  </p>
);
